import timeUtil from '../common/time-util'
import user from "./model/useInfor"
import {
  dataDst
} from "../common/util"
import kzWrodBook from './kzWordBook.json'
import PageDict from '../store/model/useInfor'
import kzCondition from './kz-condition/kz-condition'


export const fGetColumns = (data, role) => {
  let columns = {}
  if (role) {
    columns[role] = getColumns(data.list, role)
  } else {
    data.forEach(item => {
      if (JSON.parse(item.titleTxt)) {
        columns[item.action] = getColumns(JSON.parse(item.titleTxt), item.action)
      } else {

      }
    })
  }
  return columns
}

//脱敏权限
const ifEncryption = row => {
  let encryptStats = false
  let encrypt = user.state.userCompany.notSelfBlind
  let userId = user.state.userInfo.id
  let permission = user.state.permissionMap
  if (encrypt && !permission['key129']) {
    if (parseInt(row.receptorid) !== parseInt(userId) && parseInt(row.promotorid) !== parseInt(userId) && parseInt(row.collectorid) !== parseInt(userId) && parseInt(row.appointorid) !== parseInt(userId)) {
      return encryptStats = true
    } else {
      return encryptStats = false
    }
  } else {
    return encryptStats = false
  }
}
//渲染表头数据
const getColumns = (data, role) => {
  let arr = []
  arr.push({
    type: 'selection',
    width: 30,
    align: 'center'
  }),
    data.forEach(item => {
      switch (item.key) {
        case 'index':
          handleIndex(arr, item)
          break;
        case 'id':
          handleId(arr, item)
          break;
        case 'channelname':
          handleChannel(arr, item)
          break
        case 'sourcename':
          hanleSourname(arr, item)
          break
        case 'yxlevel':
          handleYxlevel(arr, item)
          break
        case 'kzphone':
          handlePhone(arr, item)
          break
        case 'kzww':
          handleWw(arr, item)
          break
        case 'wechat':
          handleWechat(arr, item, role)
          break
        case 'kzqq':
          handleQq(arr, item)
          break
        case 'kzname':
          handleKzName(arr, item, role)
          break
        case 'typename':
          handleTypeName(arr, item)
          break
        case 'memo':
          handleMemo(arr, item)
          break
        case 'zxstyle':
          handleZxStyle(arr, item)
          break
        case 'collectorname':
          handleCollectorName(arr, item)
          break
        case 'deptsort':
          handleDeptsort(arr, item)
          break
        case 'appointname':
          handleAppointName(arr, item)
          break
        case 'shopname':
          handleShopName(arr, item)
          break
        case 'statusname':
          handleStatusName(arr, item, role)
          break
        case 'successtime':
          handleSuccessTime(arr, item)
          break
        case 'amount':
          handleAmount(arr, item)
          break
        case 'createtime':
          handleCreateTime(arr, item)
          break
        case 'receivetime':
          handleReceiveTime(arr, item)
          break
        case 'updatetime':
          handleUpdateTime(arr, item)
          break
        case 'address':
          handleAddress(arr, item)
          break
        // 邀约进店相关
        case 'submitReportStoreTime':
          handleSubmitReportStoreTime(arr, item)
          break
        case 'reportStoreTime':
          handleReportStoreTime(arr, item)
          break
        case 'reportShopReceptTime':
          handleReportShopReceptTime(arr, item)
          break
        case 'reportShopReceptorName':
          handleReportShopReceptorName(arr, item)
          break
        default:
          handleElse(arr, item)
      }
    })
  return arr
}

//处理状态过滤
const filterStatus = (key, action) => {
  let classId = ''
  switch (action) {
    case 'all':
      classId = '0'
      break
    case 'new':
      classId = '1'
      break
    case 'trace':
      classId = '2'
      break
    case 'order':
      classId = '3'
      break
    case 'come':
      classId = '4'
      break
    case 'success':
      classId = '5'
      break
    case 'invalid':
      classId = '6'
      break
    case 'custom':
      classId = '7'
      break
  }

  let status = PageDict.state.pageDict.statusMap
  let filter = []

  for (let item in status) {
    if (classId == '0') {
      filter.push({
        value: status[item].statusId,
        label: status[item].statusName,
      })
    } else if (status[item].classId == classId) {
      filter.push({
        value: status[item].statusId,
        label: status[item].statusName,
      })
    }
  }

  return filter
}


//处理咨询类型过滤
const filterZxStyle = () => {
  let zxStyle = PageDict.state.pageDict.commonMap.zxStyle
  let filter = []

  for (let item in zxStyle) {
    filter.push({
      value: zxStyle[item].dicCode,
      label: zxStyle[item].dicName,
    })
  }
  return filter
}

//处理姓名
const filterKzName = () => {
  return [{
    value: '1',
    label: '先生',
  },
    {
      value: '2',
      label: '女士',
    },
    {
      value: '0',
      label: '未知',
    },
  ]
}

//处理微信
const filterWeacht = () => {
  return [{
    value: '1',
    label: '已添上',
  },
    {
      value: '2',
      label: '未添上',
    },
    {
      value: '0',
      label: '未标记  ',
    },
  ]
}

// 处理编号 id
const handleId = (arr, item) => {
  arr.push({
    title: '编号',
    width: parseInt(item.width),
    key: item.key,
    render: (h, params) => {
      return h('span', params.row.id)
    }
  })
}

//处理编号 索引
const handleIndex = (arr, item) => {
  arr.push({
    title: '编号',
    width: parseInt(item.width),
    key: item.key,
    type: 'index',
  })
}

//处理渠道
const
  handleChannel = (arr, item) => {
    arr.push({
      title: item.title,
      width: parseInt(item.width),
      key: item.key,
      ellipsis: true,
      sortable: true,
      sortKey: 'info.SOURCEID',
      render: (h, params) => {
        return h('render-channel', {
          props: {
            channelData: params,
          },
        })
      }
    })
  }

//处理来源
const hanleSourname = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: true,
    sortKey: 'info.SOURCEID',
    render: (h, params) => {
      return h('render-source', {
        props: {
          sourceData: params,
        },
      })
    }
  })
}

//处理意向等级
const handleYxlevel = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: true,
    render: (h, params) => {
      if (params.row.yxlevel && params.row.yxlevel != '0') {
        let yxLeveObj = user.getters.getYxlevel()
        return h('span', {}, yxLeveObj.get('key' + params.row.yxlevel))
      }
    }
  })
}

//处理电话
const handlePhone = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: true,
    sortKey: 'info.KZPHONE',
    render: (h, params) => {
      if (params.row[item.key]) {
        return h('render-phone', {
          props: {
            phone: params,
            encryption: ifEncryption(params.row),
          }
        })
      }
    }
  })
}

//处理旺旺
const handleWw = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    render: (h, params) => {
      let encryption = ifEncryption(params.row)
      if (params.row['kzww']) {
        if (encryption) {
          return h('span', {}, dataDst(params.row['kzww']))
        } else {
          return h('span', {}, params.row['kzww'])
        }
      }
    }
  })
}

//处理微信
const handleWechat = (arr, item) => {
  let wxClassState = false
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    filters: filterWeacht(),
    filterMultiple: true,
    sortable: true,
    sortKey: 'info.WEFLAG',
    className:wxClassState?'filterDataClass':'',
    filterMethod(value, row) {
      return row.weflag === value
    },
    filterRemote(data) {
      if (data && data.length && data.length != 0) {
        kzCondition.mutations.setFilterSql({
          name: 'info.WEFLAG',
          data
        })
        wxClassState = true
      } else {
        kzCondition.mutations.setFilterSql(false)
        wxClassState = false
      }
      window.vue.$bus.emit('pull-kz-data')
    },
    render: (h, params) => {
      if (params.row['kzwechat']) {
        return h('render-wechat', {
          props: {
            wechat: params,
            encryption: ifEncryption(params.row),
          }
        })
      }
    }
  })
}

//处理qq
const handleQq = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width) + 13,
    key: item.key,
    ellipsis: true,
    sortable: true,
    sortKey: 'info.KZQQ',
    render: (h, params) => {
      let row = params.row
      let ncryption = ifEncryption(params.row)
      if (ncryption) {
        return (h('span', {}, dataDst(row[item.key])))
      } else {
        return (h('span', {}, row[item.key]))
      }
    }
  })
}

//处理客资姓名
const handleKzName = (arr, item, role) => {
  let nameClassState = false
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    filters: filterKzName(),
    filterMultiple: true,
    className:nameClassState?'filterDataClass':'',
    filterMethod(value, row) {
      return row.sex === value
    },
    filterRemote(data) {
      if (data && data.length && data.length != 0) {
        kzCondition.mutations.setFilterSql({
          name: 'info.SEX',
          data
        })
        nameClassState = true
      } else {
        kzCondition.mutations.setFilterSql(false)
        nameClassState = false
      }
      window.vue.$bus.emit('pull-kz-data')
    },
    render: (h, params) => {
      if (params.row.kzname) {
        return h('render-name', {
          props: {
            kzName: params,
            encryption: ifEncryption(params.row),
          },
        })
      }
    }
  })
}

//处理拍摄类型
const handleTypeName = (arr, item) => {
  arr.push({
    title: '拍摄类型',
    width: parseInt(item.width),
    key: item.key,
    sortable: true,
    ellipsis: true,
    /*        filters: item.filters,
     filterMultiple: true,*/
    render: (h, params) => {
      let row = params.row
      let arr = []
      if (kzWrodBook.shotType[row['typeid']]) {
        let src = kzWrodBook.shotType[row['typeid']].src
        let WeddingName = kzWrodBook.shotType[row['typeid']].name
        arr.push(h('img', {
          attrs: {
            src,
            title: WeddingName
          },
          style: {
            height: '18px',
            'margin-right': '4px',
            'vertical-align': 'middle',
            cursor: 'pointer',
          }
        }))
        arr.push(h('span', {
          style: {
            'vertical-align': 'middle',
          }
        }, WeddingName))
        return h('div', arr)
      }
    }
  })
}

//处理备注
const handleMemo = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    render: (h, params) => {
      if (params.row.talkimg) {
        return h('span', {
          class: {
            hoverIconKz: true
          },
          style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }
        }, [
          h('span', {
            style: {
              width: '180px',
              height: '30px',
              lineHeight: '30px',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }
          }, params.row.memo),
          h('span', {
            on: {
              click: () => {
                document.getElementById('modalImgUrl').src = params.row.talkimg
                document.getElementById('modalImg').style.display = 'block'
                document.getElementById('modalImg').onclick = () => {
                  document.getElementById('modalImgUrl').src = ''
                  document.getElementById('modalImg').style.display = 'none'
                }
              },
            }
          }, [
            h('Icon', {
              attrs: {
                title: "点击查看大图"
              },
              style: {
                marginTop: '3px',
                cursor: 'pointer',
              },
              props: {
                type: 'image',
                size: '20',
                color: '#5cadff'
              },
            })
          ])
        ])
      } else {
        return h('span', {}, [
          h('span', {
            style: {
              flaot: 'left'
            }
          }, params.row.memo),
        ])
      }
    }
  })
}

//处理咨询类型
const handleZxStyle = (arr, item) => {
  let zxClassState = false
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: true,
    sortKey: 'det.ZXSTYLE',
    filters: filterZxStyle(),
    filterMultiple: true,
    className:zxClassState?'filterDataClass':'',
    filterMethod(value, row) {
      return row.zxstyle === value
    },
    filterRemote(data) {
      if (data && data.length && data.length != 0) {
        kzCondition.mutations.setFilterSql({
          name: 'det.ZXSTYLE',
          data
        })
        this.zxClassState = true
      } else {
        kzCondition.mutations.setFilterSql(false)
        this.zxClassState = false
      }
      window.vue.$bus.emit('pull-kz-data')
    },
    render: (h, params) => {
      if (params.row.zxstyle || params.row.zxstyle == '0') {
        let name = ''
        user.state.pageDict.commonMap.zxStyle.forEach(item => {
          if (parseInt(item.dicCode) === parseInt(params.row.zxstyle)) {
            name = item.dicName
          }
        })
        return h('span', {}, name)
      }
    }
  })
}


//处理推广姓名
const handleCollectorName = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: true,
    sortKey: 'info.COLLECTORID',
    /*filters: item.filters,
     filterMultiple: true,*/
    filterMethod(value, row) {
      return row.collectorid === value
    },
    filterRemote(data) {
      window.vue.$bus.emit(window.vue.$route.meta.pathName + 'FilterRemote', {
        label: 'extend',
        value: data
      });
    },
    render(h, params) {
      return h('business', {
        props: {
          userInfo: {
            staffId: params.row.collectorid,
            name: params.row[item.key],
            kzId: params.row.kzid
          },
        }
      })
    }
  })
}

//处理 客服组
const handleDeptsort = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: true,
    sortKey: 'det.DEPTSORT',
    // filters: item.filters,
    // filterMultiple: true,
    filterMethod(value, row) {
      return row.deptsort === value
    },
    filterRemote(data) {
      window.vue.$bus.emit(window.vue.$route.meta.pathName + 'FilterRemote', {
        label: 'kfz',
        value: data
      });
    },
    render: (h, params) => {
      return h('span', {}, params.row.groupname)
    }
  })
}

//处理客服姓名
const handleAppointName = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: true,
    sortKey: 'info.APPOINTID',
    // filters: item.filters,
    // filterMultiple: true,
    filterMethod(value, row) {
      return row.appointid === value
    },
    filterRemote(data) {
      window.vue.$bus.emit(window.vue.$route.meta.pathName + 'FilterRemote', {
        label: 'kefu',
        value: data
      });
    },
    render: (h, params) => {
      if (params.row.appointname) {
        return h('business', {
          props: {
            userInfo: {
              staffId: params.row.appointorid,
              name: params.row[item.key],
              kzId: params.row.kzid,
              iconType: params.row['allottype']
            },
          }
        })
      }
    }
  })
}

//处理拍摄地
const handleShopName = (arr, item) => {
  arr.push({
    title: '拍摄地',
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: true,
    sortKey: 'info.SHOPID',
    // filters: item.filters,
    // filterMultiple: true,
    filterMethod(value, row) {
      return row.shopid === value
    },
    filterRemote(data) {
      window.vue.$bus.emit(window.vue.$route.meta.pathName + 'FilterRemote', {
        label: 'shop',
        value: data
      });
    },
  })
}

//处理客资状态
const handleStatusName = (arr, item, role) => {
  let classState = false
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: true,
    sortKey: 'info.STATUSID',
    filters: filterStatus(item.key, role),
    filterMultiple: true,
    className:classState?'filterDataClass':'',
    filterMethod(value, row) {
      return row.statusid === value
    },
    filterRemote(data) {
      if (data && data.length && data.length != 0) {
        kzCondition.mutations.setFilterSql({
          name: 'info.STATUSID',
          data
        })
        classState = true
      } else {
        kzCondition.mutations.setFilterSql(false)
        classState = false
      }
      window.vue.$bus.emit('pull-kz-data');
    },
    render(h, params) {
      if (user.state.pageDict.statusMap[params.row.statusid]) {
        return h('span', {}, user.state.pageDict.statusMap[params.row.statusid].statusName)
      }
    }
  })
}

//处理订单时间
const handleSuccessTime = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: true,
    render(h, params) {
      if (params.row.successtime !== '') {
        return (h('span', {}, timeUtil.getDate(params.row.successtime)))
      }
    }
  })
}

//处理套系金额
const handleAmount = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: true,
    render(h, params) {
      if (params.row.amount && params.row.amount !== "0") {
        let encryption = ifEncryption(params.row)
        if (encryption) {
          return h('span', {}, dataDst(params.row.amount))
        } else {
          if (params.row.orderimg) {
            return h('span', {
              class: {
                hoverIconKz: true
              },
              style: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }
            }, [
              h('span', {
                style: {
                  width: '180px',
                  height: '30px',
                  lineHeight: '30px',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                }
              }, params.row.amount),
              h('span', {
                on: {
                  click: () => {
                    document.getElementById('modalImgUrl').src = params.row.orderimg
                    document.getElementById('modalImg').style.display = 'block'
                    document.getElementById('modalImg').onclick = () => {
                      document.getElementById('modalImgUrl').src = ''
                      document.getElementById('modalImg').style.display = 'none'
                    }
                  },
                }
              }, [
                h('Icon', {
                  attrs: {
                    title: "点击查看大图"
                  },
                  style: {
                    marginTop: '3px',
                    cursor: 'pointer',
                  },
                  props: {
                    type: 'image',
                    size: '20',
                    color: '#5cadff'
                  },
                })
              ])
            ])
          } else {
            return h('span', {}, [
              h('span', {
                style: {
                  float: 'left'
                }
              }, params.row.amount),
            ])
          }
        }
      }
    }
  })
}

//处理创建时间
const handleCreateTime = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: true,
    sortKey: 'info.CREATETIME',
    render(h, params) {
      if (params.row.createtime !== '') {
        return (h('span', {}, timeUtil.getDate(params.row.createtime)))
      }
    }
  })
}

//处理领取时间
const handleReceiveTime = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: true,
    render(h, params) {
      if (params.row.receivetime !== '') {
        return (h('span', {}, timeUtil.getDate(params.row.receivetime)))
      }
    }
  })
}

//处理最后操作时间
const handleUpdateTime = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: true,
    sortKey: 'info.UPDATETIME',
    render(h, params) {
      if (params.row[item.key] !== '') {
        return h('span', {}, timeUtil.getDate(params.row[item.key]))
      }
    }
  })
}

//处理地址
const handleAddress = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,

  })
}

//处理其他类型
const handleElse = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
  })
}


// 邀约进店相关

//处理邀约提报日期时间
const handleSubmitReportStoreTime = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    // sortable: true,
    // sortKey: 'info.UPDATETIME',
    render(h, params) {
      if (params.row[item.key] !== '') {
        return h('span', {}, timeUtil.getDate(params.row[item.key]))
      }
    }
  })
}

//处理预约进店日期时间
const handleReportStoreTime = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    // sortable: true,
    // sortKey: 'info.UPDATETIME',
    render(h, params) {
      if (params.row[item.key] !== '') {
        return h('span', {}, timeUtil.getDate(params.row[item.key]))
      }
    }
  })
}

//处理实际到店日期时间
const handleReportShopReceptTime = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    // sortable: true,
    // sortKey: 'info.UPDATETIME',
    render(h, params) {
      if (params.row[item.key] !== '') {
        return h('span', {}, timeUtil.getDate(params.row[item.key]))
      }
    }
  })
}


//处理进店门市接待员名称
const handleReportShopReceptorName = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    // sortable: true,
    // sortKey: 'info.APPOINTID',
    // filters: item.filters,
    // filterMultiple: true,
    filterMethod(value, row) {
      return row.appointid === value
    },
    filterRemote(data) {
      window.vue.$bus.emit(window.vue.$route.meta.pathName + 'FilterRemote', {
        label: 'kefu',
        value: data
      });
    },
    render: (h, params) => {
      if (params.row.reportShopReceptorName) {
        return h('business', {
          props: {
            userInfo: {
              staffId: params.row.reportShopReceptorId,
              name: params.row[item.key],
              kzId: params.row.kzid,
              iconType: params.row['allottype']
            },
          }
        })
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/store/util.js